
                import { sts, stc } from "/home/builduser/work/5d4c7c61b0622e62/.yarn/__virtual__/@wix-santa-editor-infra-virtual-e2745908eb/1/infra/stylable-runtime"; 
                import "/home/builduser/.yarn/berry/cache/@wix-wix-base-ui-next-npm-0.98.0-82a03733d3-10.zip/node_modules/@wix/wix-base-ui-next/dist/esm/atoms/TextButton/TextButton.st.css";
                export const namespace = "TextButton4166777016";
                export const classes = {"root":"TextButton4166777016__root","weight-thin":"Typography42144321__weight-thin","weight-normal":"Typography42144321__weight-normal","text":"TextButton4166777016__text"};
                export const keyframes = {};
                export const stVars = {};
                export const vars = {};
                export const cssStates = /* @__PURE__ */ stc.bind(undefined, namespace);
                export const st = /* @__PURE__ */ sts.bind(undefined, namespace);
                export const style = st;
                